import React from 'react';

import { useFrontChatEvents, useFrontChatInit, useFrontChatVisibility } from '../hooks';

import { ChatLauncher } from './ChatLauncher';

/**
 * FrontChat component handles the Front Chat SDK integration
 * It initializes the chat, manages events, and controls visibility
 */
export const FrontChat = () => {
  // Initialize Front Chat
  const { frontChat, isInitialized } = useFrontChatInit();

  // Handle Front Chat events and Redux sync
  useFrontChatEvents(frontChat, isInitialized);

  // Manage launcher visibility based on routes
  useFrontChatVisibility(isInitialized);

  // This component doesn't render anything visible
  return <ChatLauncher />;
};
